/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type UserEntity, userSchema } from '@axiom/domain';

export const ownerUserSchema = userSchema.pick({ "fullName": true, "id": true });
export type OwnerUser = Pick<UserEntity, "fullName" | "id"> & z.infer<typeof ownerUserSchema>;
